import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ImgLoaderEmitterService {
  public loaderEmitter: Subject<number> = new Subject<number>();
}
